
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_2","data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 27.38 29.38"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M13.62 1.37l.06.33.76.06c5.26.39 9.38 4.83 9.38 10.1v10.8h1.28c.7 0 1.27.57 1.27 1.27s-.57 1.27-1.27 1.27H2.27c-.7 0-1.27-.57-1.27-1.27s.57-1.27 1.27-1.27h1.28v-10.8c0-5.22 4.07-9.65 9.26-10.1l.76-.07.06-.32m0-1.37c-.46 0-.82.33-.9.77-5.71.49-10.18 5.26-10.18 11.08v9.8h-.28C1.02 21.65 0 22.67 0 23.92s1.02 2.27 2.27 2.27h22.84c1.25 0 2.27-1.02 2.27-2.27s-1.02-2.27-2.27-2.27h-.28v-9.8c0-5.87-4.54-10.67-10.3-11.09a.922.922 0 00-.9-.76zM14.87 27.51h-2.36a.939.939 0 100 1.88h2.36a.939.939 0 100-1.88z"}})])])
          )
        }
      }
    